import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Apple, Disc3, Globe, Headphones, Instagram, Music2, Twitter, Youtube } from "lucide-react";
import { Logo } from "@/components/Logo";
import { api } from "@/lib/api";

const ICONS = { instagram: Instagram, youtube: Youtube, tiktok: Music2, x: Twitter, spotify: Disc3, soundcloud: Headphones, "apple music": Apple };

export const Footer = () => {
  const [socials, setSocials] = useState([]);

  useEffect(() => {
    api.get("/socials").then((r) => setSocials(r.data)).catch(() => {});
  }, []);

  return (
    <footer className="border-t border-white/10 bg-[#08080A]" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:grid-cols-3 sm:px-6 lg:px-8">
        <div>
          <div className="flex items-center gap-3">
            <Logo size={34} />
            <span className="font-heading text-lg font-extrabold text-white">
              PRODRUSHI<span className="text-emerald-300">.</span>
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-zinc-500">
            Crafted in Atlanta, Georgia. Hard-hitting Trap, R&B, Drill & Melodic production for recording artists worldwide.
          </p>
          <div className="mt-5 flex flex-wrap gap-2" data-testid="footer-socials">
            {socials.map((s) => {
              const Icon = ICONS[s.platform.toLowerCase()] || Globe;
              return (
                <a
                  key={s.id}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.platform}
                  data-testid={`footer-social-${s.platform.toLowerCase()}-${(s.handle || "").replace(/[^a-z0-9]/gi, "").toLowerCase()}`}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 text-zinc-400 transition-colors hover:border-emerald-300/50 hover:text-emerald-200"
                >
                  <Icon size={15} />
                </a>
              );
            })}
          </div>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-widest text-emerald-300">Navigate</p>
          <div className="mt-4 grid grid-cols-2 gap-2 text-sm">
            {[["/beats", "Beats Store"], ["/catalog", "Catalog"], ["/showcase", "Showcase"], ["/photography", "Photography"], ["/videography", "Videography"], ["/booking", "Book Studio"], ["/socials", "Socials"], ["/contact", "Contact"]].map(([to, label]) => (
              <Link key={to} to={to} className="text-zinc-400 transition-colors hover:text-emerald-200" data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}>
                {label}
              </Link>
            ))}
          </div>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-widest text-emerald-300">Studio</p>
          <p className="mt-4 text-sm text-zinc-400">Blackroom Studios</p>
          <p className="text-sm text-zinc-500">Atlanta, Georgia</p>
          <p className="mt-4 text-xs text-zinc-600">© {new Date().getFullYear()} PRODRUSHI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
